var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBestSellerEmployeeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "1.87rem",
    viewBox: "0 0 45 36.374",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "user-tag-solid",
    d: "M15.913,18.187A9.093,9.093,0,1,0,6.82,9.093,9.093,9.093,0,0,0,15.913,18.187ZM12.667,21.6A12.664,12.664,0,0,0,0,34.264a2.11,2.11,0,0,0,2.11,2.11H29.717a2.1,2.1,0,0,0,1.719-.888l-7.047-7.047a5.642,5.642,0,0,1-1.655-3.985V22.108A12.594,12.594,0,0,0,19.16,21.6H12.667ZM27.28,15.913a2.271,2.271,0,0,0-2.273,2.273v5.875a4.548,4.548,0,0,0,1.328,3.218l7.63,7.623a3.417,3.417,0,0,0,4.824,0L44,29.689a3.417,3.417,0,0,0,0-4.824l-7.63-7.623a4.548,4.548,0,0,0-3.218-1.328ZM28.985,21.6A1.705,1.705,0,1,1,30.69,23.3,1.705,1.705,0,0,1,28.985,21.6Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBestSellerEmployeeIcon);
export default __webpack_public_path__ + "static/media/best-seller-employee-icon.b486e38870724ecd037c3bb27251c925.svg";
export { ForwardRef as ReactComponent };